// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fx","catalogByServiceItem__title":"c-k_fy"};